
import {KecPath, Service, Version, source} from './constants';

// 校验专属宿主机库存资源
export const CheckDedicatedHostCapacity = {
    basePath: KecPath,
    method: 'get',
    params: {
        Action: 'CheckDedicatedHostCapacity',
        Service,
        Version,
        source
    }
}

//宿主机列表
export const DescribeDedicatedHosts = {
    basePath: KecPath,
    method: 'get',
    params: {
        Action: 'DescribeDedicatedHosts',
        Service,
        Version,
        source
    }
};
//删除宿主机
export const DeleteDedicatedHost = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DeleteDedicatedHost',
        Service,
        Version,
        source
    }
};
//修改名称
export const RenameDedicatedHost = {
    basePath: KecPath,
    params: {
        Action: 'RenameDedicatedHost',
        Service,
        Version,
        source
    }
};
//查询专属宿主机套餐
// export const QueryDedicatedHostPackage = {
//     method: 'get',
//     basePath: KecPath,
//     params: {
//         Action: 'QueryDedicatedHostPackage',
//         Service,
//         Version,
//         source,
//         operateType: 1 //创建是1
//     }
// };
export const QueryDedicatedHostPackage = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'QueryPriceSystem',
        Service,
        Version,
        source,
        // operateType: 1 //创建是1
    }
};
//创建专属宿主机商品
export const CreateDedicatedHostProduct = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CreateDedicatedHostProduct',
        Service,
        Version,
        source
    }
};

// 计算专属宿主机价格、
export const CalculateDedicatedHostProduct = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CalculateDedicatedHostProduct',
        Service,
        Version,
        source
    }
};

// 计算续费价格
export const calcRenew = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CalculateDedicatedRenewal',
        Service,
        Version,
        source
    }
};

//续费宿主机
export const dedicatedRenew = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DedicatedRenewalProduct',
        Service,
        Version,
        source
    }
};
//根据ID查询支持的计费类型
export const QueryBillTypeByDedicatedIds = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'QueryBillTypeByDedicatedIds',
        Service,
        Version,
        source
    }
};
// 创建试用专属宿主机续费商品接口
export const tryDedicatedRenew = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DedicatedTrialProductRenewal',
        Service,
        Version,
        source
    }
};
//创建试用专属宿主机转正商品接口
export const tryDedicatedPositive = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DedicatedTrialToBuy',
        Service,
        Version,
        source
    }
};
export const exclusiveMonitor = {
    method: 'get',
    basePath: '/monitorapi/dashboard/get',
    params: {
        Service,
        source
    }
};


//描述专属集群接口
export const getDedicatedCluster = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeDedicatedCluster',
        Service,
        Version,
        source
    }
};

//修改集群名称
export const modifyclusterName = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ModifyDedicatedClusterName',
        Service,
        Version,
    }
};

//创建集群
export const createDedicatedCluster = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CreateDedicatedCluster',
        Service,
        Version,
        source
    }
};
//删除集群
export const delDedicatedCluster = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DeleteDedicatedCluster',
        Service,
        Version,
        source
    }
};
//专属宿主机更改集群
export const migrateExclusiveCluster = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DedicatedHostMigrate',
        Service,
        Version,
        source
    }
};
//设置虚拟核数量
export const setVCPU = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'SetvCPU',
        Service,
        Version,
        source
    }
};
export const exclusiveOverview = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeKDCResourceView',
        Service,
        Version,
        source
    }
};

//获取一级标签
export const DescribeTagKeysV2 = {
    basePath: KecPath,
    params: {
        Action: 'DescribeTagKeysV2',
        Version: '2020-09-01',
        Service: 'tag',
        maxResults: 200,
        source
    },
    method: 'get'
};

//根据一级标签获取二级标签
export const DescribeTagValuesV2 = {
    basePath: KecPath,
    params: {
        Action: 'DescribeTagValuesV2',
        Version: '2020-09-01',
        Service: 'tag',
        maxResults: 200,
        nextToken: '',
        source
    },
    method: 'get'
};

//专属宿主机绑定标签
export const ReplaceResourcesTagsV2 = {
    basePath: KecPath,
    params: {
        Action: 'ReplaceResourcesTagsV2',
        Version: '2020-09-01',
        Service: 'tag',
        source
    },
    method: 'post'
};

//专属宿主机解绑标签
export const DetachResourceTagsV2 = {
    basePath: KecPath,
    params: {
        Action: 'DetachResourceTagsV2',
        Version: '2020-09-01',
        Service: 'tag',
        source
    },
    method: 'post'
};

export const ModifyVolumeType = {
    basePath: KecPath,
    params: {
        Action: 'ModifyVolumeType',
        Version,
        Service,
        source
    },
    method: 'post'
};


//专属宿主机解绑标签
export const ModifyEbsClusterMode = {
    basePath: KecPath,
    params: {
        Action: 'ModifyEbsClusterMode',
        Version,
        Service,
        source
    },
    method: 'post'
};

